<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        {{ pageTitle }}
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="150px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Tên yêu cầu" prop="requestName">
              <el-input
                v-model="form.requestName"
                placeholder="Tên yêu cầu"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="100"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Nội dung yêu cầu" prop="requestContent">
              <el-input
                type="textarea"
                v-model="form.requestContent"
                placeholder="Nội dung yêu cầu"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="500"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <hc-ks-upload
              ref="hcMaybayToTrinhRef"
              :hcCaseFlightFileType="
                HC_CASE_FLIGHT_FILE.TYPE.KHACH_SAN.TO_TRINH
              "
              :id="id"
            ></hc-ks-upload>
          </el-col>

          <el-col :span="24" class="margin-bottom-5">
            <hc-ks-users
              v-if="!!hcCaseHotel"
              ref="hcMaybayUsers"
              :hcCaseMasterId="hcCaseHotel.caseMasterId"
            ></hc-ks-users>
          </el-col>

          <el-col
            :span="24"
            v-if="
              hcFlowInstance &&
                hcFlowInstance.currentStateCode ===
                  HC_STATE.STATE_CODE.MAY_BAY.DA_PHE_DUYET
            "
          >
            <hc-ks-upload
              :hcCaseFlightFileType="
                HC_CASE_FLIGHT_FILE.TYPE.KHACH_SAN.VE_KHACH_SAN
              "
              :id="id"
              ref="hcMaybayVeKhachSanRef"
            ></hc-ks-upload>
          </el-col>

          <el-col :span="24" v-if="!!hcCaseHotel">
            <hc-ks-places
              ref="hcKsPlacesRef"
              v-if="!!hcCaseHotel"
              :hcCaseMasterId="hcCaseHotel.caseMasterId"
            ></hc-ks-places>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Ghi chú" prop="note">
              <el-input
                type="textarea"
                v-model="form.note"
                placeholder="Ghi chú"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="500"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="submit"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;{{ buttonTitle }}
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
  import h from "../../../services/h";
  import hcCaseMasterService from "../../../services/hcCaseMasterService";
  import hcFlowInstanceService from "../../../services/hcFlowInstanceService";
  import hcCaseHotelService from "../../../services/khachsan/hcCaseHotelService";
  import utils from "../../../services/utils";
  import uploadFileMixin from "../../doc-in/uploadFileMixin";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import vbAttachmentTokenMixin from "../../../mixins/vbAttachmentTokenMixin";
  import HcKsPlaces from "./hc-ks-places";
  import HcKsUpload from "./hc-ks-upload";
  import HcKsUsers from "./hc-ks-users";
  import HcKsUsersReadonly from "./hc-ks-users-readonly";
  import CustomDialog from "../../common/custom-dialog";
  import errorMessageFilter from "../../../filters/errorMessageFilter";
  import constants from "../../../constants";
  import hanhChinhUtils from "../../../services/hanhChinhUtils";

  export default {
    name: "hc-ks-update-dialog",
    mixins: [handleRequestErrorMixin, uploadFileMixin, vbAttachmentTokenMixin],
    props: ["isOpen", "id"],
    components: {
      HcKsUsers,
      HcKsPlaces,
      HcKsUpload,
      HcKsUsersReadonly,
      CustomDialog
    },

    data() {
      return {
        rules: {
          note: null,
          flightRouteList: null,
          flightFileList: null,
          requestName: null,
          requestContent: null,
        },
        form: {
          requestName: null,
          requestContent: null,
          note: null,
          flightRouteList: [],
          flightFileList: []
        },
        hcCaseHotel: null,
        HC_CASE_FLIGHT_FILE: constants.HC_CASE_FLIGHT_FILE,
        veMayBayValidateFileOptions: null,
        pageTitle: null,
        buttonTitle: null,
        hcFlowInstance: null,
        hcCaseMaster: null,
        HC_STATE: constants.HC_STATE
      };
    },

    computed: {},

    watch: {},

    async created() {
      this.initPageTitle();
      this.initValidationRules();
      this.initMayBayFileValidateFileOptions();
      await this.loadHcCaseHotel();
      await this.loadHcCaseMaster();
      await this.loadHcFlowInstance();
      this.initFormForEdit();
    },

    methods: {
      loadHcFlowInstance() {
        return hcFlowInstanceService
          .findById(this.hcCaseMaster.flowInstanceId)
          .then(response => (this.hcFlowInstance = response.data));
      },

      loadHcCaseMaster() {
        return hcCaseMasterService
          .findById(this.hcCaseHotel.hcCaseMasterId)
          .then(response => (this.hcCaseMaster = response.data));
      },

      initPageTitle() {
        this.pageTitle = "Cập nhật yêu cầu đặt phòng khách sạn";
        this.buttonTitle = "Cập nhật";
      },

      initMayBayFileValidateFileOptions() {
        this.veMayBayValidateFileOptions = hanhChinhUtils.initMayBayFileValidateFileOptions(
          constants.HC_CASE_FLIGHT_FILE.TYPE.VE_MAY_BAY
        );
      },

      initFormForEdit() {
        console.log(JSON.stringify(this.hcCaseHotel));
        this.form.requestName = this.hcCaseHotel.requestName;
        this.form.requestContent = this.hcCaseHotel.requestContent;
        this.form.note = this.hcCaseHotel.note;
      },

      loadHcCaseHotel() {
        return hcCaseHotelService
          .findById(this.id)
          .then(response => (this.hcCaseHotel = response.data));
      },

      initValidationRules() {
        let defaultRequiredConstrains = {
          required: true,
          message: "Trường dữ liệu bắt buộc",
          trigger: "blur"
        };
        this.rules.note = [defaultRequiredConstrains];
        this.rules.requestName = [defaultRequiredConstrains];
        this.rules.requestContent = [defaultRequiredConstrains];
      },

      validateVeKhachSan() {
        return new Promise(resolve => {
          if (
            this.hcFlowInstance.currentStateCode ===
            constants.HC_STATE.STATE_CODE.MAY_BAY.CHO_PHE_DUYET
          ) {
            resolve();
          } else {
            let files = this.$refs.hcMaybayVeKhachSanRef.getData();
            if (!files || !files.length) {
              this.$message.error(
                errorMessageFilter({errorCode: "hcHotel.ticketFiles.required"})
              );
            } else {
              resolve();
            }
          }
        });
      },

      validateToTrinh() {
        return new Promise(resolve => {
          let files = this.$refs.hcMaybayToTrinhRef.getData();
          if (!files || !files.length) {
            this.$message.error(
              errorMessageFilter({errorCode: "hcMayBay.files.required"})
            );
          } else {
            resolve();
          }
        });
      },

      validateUsers() {
        return new Promise(resolve => {
          let files = this.$refs.hcMaybayUsers.getData();
          if (!files || !files.length) {
            this.$message.error(
              errorMessageFilter({errorCode: "hcHotel.users.required"})
            );
          } else {
            resolve();
          }
        });
      },

      validatePlaces() {
        return new Promise(resolve => {
          let hotels = this.$refs.hcKsPlacesRef.getData();
          if (!hotels || !hotels.length) {
            this.$message.error(
              errorMessageFilter({errorCode: "hcHotel.hotels.required"})
            );
          } else {
            resolve();
          }
        });
      },


      validateForm() {
        return utils.validateFormCommon(this.$refs.form, this.$message);
      },

      convertToSubmitForm() {
        let users = h.collect(this.$refs.hcMaybayUsers.getData(), user => {
          return {
            userName: user.userName,
            email: user.email,
            gender: user.gender,
            birthday: user.birthday,
            isdn: user.isdn,
            identityNumber: user.identityNumber,
            positionId: user.positionId,
            deptId: user.deptId,
            checker: user.isCheckIn ? constants.TRUE : constants.FALSE
          };
        });

        let hotels = h.collect(this.$refs.hcKsPlacesRef.getData(), place => {
          return {
            locationId: place.location,
            hotelId: place.hotel,
            checkIn: place.checkIn,
            checkOut: place.checkOut,
            countRoom1: place.countRoom1,
            countRoom2: place.countRoom2
          };
        });

        let files = this.$refs.hcMaybayVeKhachSanRef ?
          this.$refs.hcMaybayVeKhachSanRef.getData() : null;
        let toTrinhFiles = this.$refs.hcMaybayToTrinhRef ?
          this.$refs.hcMaybayToTrinhRef.getData() : null;

        return {
          action: constants.HC_STATE_TO_STATE.ACTION_CODE.MAY_BAY.CAP_NHAT,
          caseMasterId: this.hcCaseHotel.caseMasterId,
          requestName: this.form.requestName,
          requestContent: this.form.requestContent,
          note: this.form.note,
          files: files,
          toTrinhFiles: toTrinhFiles,
          hotels: hotels,
          users: users
        };
      },

      submit() {
        this.validateForm()
          .then(() => this.validateToTrinh())
          .then(() => this.validateVeKhachSan())
          .then(() => this.validateUsers())
          .then(() => this.validatePlaces())
          .then(() => {
            let submitForm = this.convertToSubmitForm();
            return hcCaseHotelService
              .update(submitForm)
              .then(response => response.data);
          })
          .then(hcCaseHotel => {
            this.$message.success(
              errorMessageFilter({
                errorCode: "hcHotel.updateSuccess"
              })
            );
            this.$emit("updateSuccess", {result: hcCaseHotel});
          })
          .catch(error => {
            this.commonHandleRequestError(error);
            throw error;
          });
      }
    }
  };
</script>

<style type="text/css" scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/khachsan/hc-ks-update-dialog.vue